import apiWorker from '../apiWorker'

const contacts = {
    update : (contact_id, data, hideErr)   =>  apiWorker('patch', `/v1/api/contacts/${contact_id}`, data, hideErr),
    register : (data)   =>  apiWorker('post', `/v1/api/contacts/register`, data),
}

export default contacts;